import React from 'react';
import PropTypes from 'prop-types';

const ChevronRightIcon = ({ size = 20, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

ChevronRightIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default ChevronRightIcon;
